import React, { useEffect } from "react";
import "./Invoice80mm.css";
import { dynamicImage } from "../../../../Service";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";

const ClothInvoice = () => {
     const params = useParams();
    const clothCalculationId = params.id || "0";
    const [items, setItems] = React.useState<any[]>([]);
  // const items = [
  //   { size: "S", quantity: 1, gender: "Male", price: 0 },
  //   { size: "M", quantity: 2, gender: "Female", price: 0 },
  // ];

  const clothDetails = async () => {
      try {
        const res = await api.get(`/api/ClothCalculation/ClothingBilling?clothCalculationId=${clothCalculationId}`);
        if (res.status === 200) {
          // Process the response data
          const data = Array.isArray(res.data) ? res.data : [];
          setItems(data);
        }
      } catch (error) {
        // console.error("Error fetching food order:", error);
      }
    };

   useEffect(() => {
    clothDetails();
      if (items.length > 0) {
          window.print();
      } else {
          setTimeout(window.print, 1000);
      }
    }, []);
    const handlePrint = () => {
      window.print();
    };

  return (
    <>
      {items.length > 0 && (
    <div className='page-body'>
      <div className="invoice-container">
        <button className="print-button" onClick={handlePrint}>🖨️ Print</button>
        <div className="invoice">
          <div className="logo">
            <img src={dynamicImage("logo/logo.png")} alt="Logo" />
            <h2>SHIVALYA WATER PARK</h2>
          </div>

          <div className="details">
            <p><strong>Ticket No.:</strong> {items[0].ticketIDRef}</p>
            <p><strong>RFID Card No.:</strong> {items[0].rfidCardNumber}</p>
            <p><strong>Customer Name:</strong> {items[0].customerName}</p>
            <p><strong>Mobile Number:</strong> {items[0].customerMobileNumber}</p>
          </div>

          <table className="item-table">
            <thead>
              <tr>
                <th>Size</th>
                <th>Gender</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={i}>
                  <td>{item.size}</td>
                  <td>{item.gender}</td>
                  <td>{item.clothQuantity}</td>
                  <td>Rs {item.clothPrice.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="totals">
            <p><strong>Sub Total :</strong> Rs {items[0].subTotalAmount}</p>
            <p><strong>GST :</strong> Rs {items[0].gst}</p>
            <p><strong>Refund Amount :</strong> Rs {items[0].refundAmount}</p>
            <p><strong>Total Amount :</strong> Rs {items[0].grandTotalAmount}</p>
          </div>
        </div>
      </div>
    </div>
      )}
    </>
  );
};

export default ClothInvoice;
